import React, { Component } from 'react'
import { Button } from "antd";
import './Home.scss'
export default class Home extends Component {
    render() {
        return (
            <div className="Home">
            <div className="container animation">
              <div className="detail">
                <p>
                  <strong>CitySCENE</strong> is a new large-scale anomaly dataset consisting of a variety of real-world anomalies, which have a significant impact on city management and public safety. CitySCENE can be used to compare algorithms for anomaly detection in real-world: general anomaly detection and specific anomaly detection.
                </p>
              </div>
                <div className="bt">
                  <Button  style={{marginRight:"10px"}} type="primary">Challenge</Button>
                  <Button  style={{marginRight:"10px"}} type="primary">Dataset</Button>
                </div>
              </div>
            <div className="bottom-text">
            </div>
          </div>
        )
    }
}
